import { getVendorTaxonomyId } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';
import { StorefrontCardView } from '@zola/svc-marketplace-ts-types';

import { UserSettingsObjectType } from '~/actions/couples/types/userSettingsActionTypes';
import { vendorTypeKeyToUserSettingsKey } from '~/reducers/couples/userSettingsReducer';
import {
  AccountVendorPreferencesView,
  AccountWeddingPreferencesView,
  TaxonomyNodeType,
} from '~/types/responseTypes';
import { IUserContext } from '~/types/userContext';

import { VendorSearchRequest } from '../../types/types';

export const NUM_TOP_PICKS = 5;

export const topPicksFilter = (vendors: StorefrontCardView[]): StorefrontCardView[] =>
  vendors.filter((vendor) => vendor.imageIds[0] && vendor.badges && vendor.badges.length > 0);

export const areTopPicksAllowedForPreferencesAndCategory = (
  weddingPreferences: AccountWeddingPreferencesView | null,
  vendorPreferences: AccountVendorPreferencesView[],
  selectedTaxonomy: VendorSearchRequest['selectedTaxonomy']
) => {
  const hasWeddingPreferences = Boolean(weddingPreferences?.uuid);

  if (selectedTaxonomy && hasWeddingPreferences) {
    const { key: taxonomyKey } = selectedTaxonomy;

    const taxonomyNodeId = getVendorTaxonomyId(taxonomyKey) as number;
    return Boolean(vendorPreferences.find((pref) => pref.taxonomyNodeId === taxonomyNodeId));
  }
  return false;
};

type TopPickType = {
  weddingPreferences: AccountWeddingPreferencesView | null;
  vendorPreferences: AccountVendorPreferencesView[];
  selectedTaxonomy: VendorSearchRequest['selectedTaxonomy'];
  userSettings: UserSettingsObjectType;
  userContext: IUserContext | null;
};

type TopPickAllowType = TopPickType & {
  weddingPreferences: AccountWeddingPreferencesView;
  vendorPreferences: AccountVendorPreferencesView[];
  selectedTaxonomy: TaxonomyNodeType;
  userSettings: UserSettingsObjectType;
  userContext: IUserContext;
};

export const areTopPicksAllowedForUserInLocation = (
  props: TopPickType
): props is TopPickAllowType => {
  const { weddingPreferences, vendorPreferences, selectedTaxonomy, userSettings, userContext } =
    props;

  const userSawTopPicksInCategory =
    userSettings[vendorTypeKeyToUserSettingsKey(selectedTaxonomy?.key)]?.flag;
  const userHasCompletedOnboarding = userContext?.has_completed_onboarding;

  return Boolean(
    areTopPicksAllowedForPreferencesAndCategory(
      weddingPreferences,
      vendorPreferences,
      selectedTaxonomy
    ) &&
      userHasCompletedOnboarding &&
      !userSawTopPicksInCategory
  );
};
